import { forwardRef, useImperativeHandle, useRef, useMemo, useState } from 'react';
import { useFormikContext } from 'formik';
import { pluck } from '../../helpers/pluck';

interface FileInputProps {
  onChange?: (file: string) => void;
  resourceId?: string;
  resource?: string;
  name: string;
  nameFile?: string;
}

export const FileInput = forwardRef<HTMLInputElement, FileInputProps>(
  ({ nameFile, name }, ref) => {
    const inputRef = useRef<HTMLInputElement>(null);
    const { errors, setFieldValue } = useFormikContext();
    const [currentPath, setCurrentPath] = useState('');

    useImperativeHandle(ref, () => inputRef.current!);
    const theError = useMemo(() => pluck(name, errors) || undefined, [errors, name]);

    const triggerFileSelect = () => inputRef.current?.click();

    const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
      if (event.target.files && event.target.files[0]) {
        const fileName = Array.from(event.target.files).reduce((acc, file) => `${file.name},` + acc, '')
        setFieldValue(name, event.target.files);
        setCurrentPath(fileName);
      }
    };

    return (
      <div>
        <div className="custom-file-input">
          <button type="button" className="m-2 bg-redPrimary text-white" onClick={triggerFileSelect}>{nameFile}</button>
        </div>
        <input
          type="file"
          ref={inputRef}
          multiple
          className="hidden"
          onChange={handleFileChange}
          aria-invalid={Boolean(pluck(name, errors))}
        />
        {theError ? <small className="text-redPrimary/90" aria-live="polite">{theError}</small> : null}
        {currentPath && (
          <span className="pt-4">
            <span className="text-bluePrimary">{currentPath}</span>
          </span>
        )}
      </div>
    );
  });
